const currentDate = new Date();
const yearOffsets = [-1, -2];
const isFallTerm = currentDate.getMonth() > new Date("1 june 2021").getMonth();
if (isFallTerm) yearOffsets.unshift(0);

const projectYears = yearOffsets.map((yearOffset) => {
  const startDate = new Date(
    new Date(
      new Date().setFullYear(currentDate.getFullYear() + yearOffset)
    ).setMonth(6)
  );
  const endDate = new Date(
    new Date(
      new Date().setFullYear(currentDate.getFullYear() + yearOffset + 1)
    ).setMonth(5)
  );

  const startYear = startDate.getFullYear().toString().substring(2, 4);
  const endYear = endDate.getFullYear().toString().substring(2, 4);

  return { name: `${startYear}/${endYear}`, value: { startDate, endDate } };
});

export default {
  projectYears,
  currentProjectYear: projectYears[0],
};
